import React from 'react';
import './portfolio.css'

function Portfolioheader() {
  return (
    <section id="portfolioheader" className="jumbotron text-center portfolioBackground">
        <h1 className="display-3">Portfolio</h1>
        <p className="lead">Collection of independent and collaborative web projects</p>
    </section>
  );
}

export default Portfolioheader;